// @ts-nocheck
; (function () {
  var object =
    typeof exports != 'undefined'
      ? exports
      : typeof self != 'undefined'
        ? self // #8: web workers
        : $.global // #31: ExtendScript

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='

  function InvalidCharacterError(message) {
    this.message = message
  }

  InvalidCharacterError.prototype = new Error()
  InvalidCharacterError.prototype.name = 'InvalidCharacterError'

  // encoder
  // [https://gist.github.com/999166] by [https://github.com/nignag]
  object.btoa ||
    (object.btoa = function (input) {
      var str = String(input)
      for (
        // initialize result and counter
        var block, charCode, idx = 0, map = chars, output = '';
        // if the next str index does not exist:
        //   change the mapping table to "="
        //   check if d has no fractional digits
        str.charAt(idx | 0) || ((map = '='), idx % 1);
        // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
        output += map.charAt(63 & (block >> (8 - (idx % 1) * 8)))
      ) {
        charCode = str.charCodeAt((idx += 3 / 4))
        if (charCode > 0xff) {
          throw new InvalidCharacterError(
            "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range."
          )
        }
        block = (block << 8) | charCode
      }
      return output
    })

  // decoder
  // [https://gist.github.com/1020396] by [https://github.com/atk]
  object.atob ||
    (object.atob = function (input) {
      var str = String(input).replace(/[=]+$/, '') // #31: ExtendScript bad parse of /=
      if (str.length % 4 === 1) {
        throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.")
      }
      for (
        // initialize result and counters
        var bc = 0, bs, buffer, idx = 0, output = '';
        // get next character
        (buffer = str.charAt(idx++));
        // character found in table? initialize bit storage and add its ascii value;
        ~buffer &&
          ((bs = bc % 4 ? bs * 64 + buffer : buffer),
            // and if not first of each 4 characters,
            // convert the first 8 bits to one ascii character
            bc++ % 4)
          ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
          : 0
      ) {
        // try to find character in table (0-63, not found => -1)
        buffer = chars.indexOf(buffer)
      }
      return output
    })

  if (window.atob === undefined) window.atob = object.atob
  if (window.btoa === undefined) window.btoa = object.btoa
})()

/* Copyright (c) 2016 Tobias Buschor https://goo.gl/gl0mbf | MIT License https://goo.gl/HgajeK */
/* focusin/out event polyfill (firefox) */
!(function () {
  var w = window,
    d = w.document

  if (w.onfocusin === undefined) {
    d.addEventListener('focus', addPolyfill, true)
    d.addEventListener('blur', addPolyfill, true)
    d.addEventListener('focusin', removePolyfill, true)
    d.addEventListener('focusout', removePolyfill, true)
  }

  function addPolyfill(e) {
    var type = e.type === 'focus' ? 'focusin' : 'focusout'
    var event = new CustomEvent(type, { bubbles: true, cancelable: false })
    event.c1Generated = true
    e.target.dispatchEvent(event)
  }

  function removePolyfill(e) {
    if (!e.c1Generated) {
      // focus after focusin, so chrome will the first time trigger tow times focusin
      d.removeEventListener('focus', addPolyfill, true)
      d.removeEventListener('blur', addPolyfill, true)
      d.removeEventListener('focusin', removePolyfill, true)
      d.removeEventListener('focusout', removePolyfill, true)
    }
    setTimeout(function () {
      d.removeEventListener('focusin', removePolyfill, true)
      d.removeEventListener('focusout', removePolyfill, true)
    })
  }
})()
